<script setup>
/*==================================================================*/
/*================== SCRIPT MODAL FULLSCREEN BASE ==================*/
/*==================================================================*/

import { ref, nextTick, defineExpose } from 'vue';
import ModalBase from '@/components/v2/base/ModalBase/ModalBase.vue';

const modalBaseRef = ref(null);

/*==================================================================*/
/*================== MÉTODOS DE CONTROLE DO MODAL ==================*/
/*==================================================================*/

const abrirModal = async () => {

    await modalBaseRef.value?.abrirModal();
    await nextTick();

};

const fecharModal = async () => {

    await modalBaseRef.value?.fecharModal();
    await nextTick();

};

defineExpose({ abrirModal, fecharModal });

</script>

<template>

    <ModalBase
        ref="modalBaseRef"
        fullscreen
        persistent
        transition="dialog-bottom-transition"
    >
        <slot></slot>
    </ModalBase>

</template>

<style scoped>
</style>
